import { SUPPORT_EMAIL } from '@/utils/support-contact.js';

export default {
  common: {
    actions: 'Actions',
    author: 'Author',
    cancel: 'Cancel',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    finish: 'Finish',
    complete: 'Complete',
    legend: 'Legend',
    surveyType: 'Type',
    paths: 'Paths',
    publish: 'Publish',
    save: 'Save',
    title: 'Title',
    type: 'Type',
    created: 'Created',
    updated: 'Updated',
    publishId: 'Publish ID',
    version: 'Version',
    yes: 'Yes',
    no: 'No',
    next: 'Next',
    previous: 'previous',
    practices: 'Practices',
    practice: 'Practice',
    required: 'Required',
    contactSupport: 'If you have any questions, please contact your program support team.',
    invalidOrExpiredLink: `The survey link is invalid or has expired. Please try to retake the Survey. If the retake also fails or you have any questions, please contact: ${SUPPORT_EMAIL}`,
    unexpectedMessage: 'WELL, THIS IS UNEXPECTED…',
    starDate: 'Start Date',
    endDate: 'End Date'
  },
  header: {
    authorization: 'Authorization',
    contentTypeKey: 'Content-Type',
    contentTypeValue: 'application/json'
  },
  survey: {
    addAQuestionToSurvey: 'ADD A QUESTION TO SURVEY',
    surveyType: 'Survey Type',
    submitSurveyTitle: 'Name Survey',
    path: 'Path',
    skipToPractice: 'Skip To Practice',
    createQuestion: 'WEEKLY WORKOUT',
    preloadVariable: 'Preloaded Variables',
    saveQuestion: 'SAVE QUESTION',
    saveVariable: 'SAVE VARIABLE',
    textSaveGroup: 'SAVE GROUP',
    textSaveOrder: 'SAVE ORDER',
    openSurveyButton: 'OPEN SURVEY',
    labelLongFormSurveyButton: 'Create A Long Survey',
    description: `Please click the button below to complete the weekly survey. Your answers will be
                kept entirely confidential and none of your personal information will be shared with
                your company. The completion of the survey confirms your participation.`,
    surveyMap: {
      cancelSurveyTitle: 'CANCEL THIS SURVEY?',
      buttonLongForm: 'GO TO LONGFORM',
      buttonSubmitSurvey: 'SUBMIT SURVEY FOR APPROVAL'
    },
    stateTitles: {
      invalid: 'INVALID SURVEY LINK',
      alreadyCompletedSurvey: 'YOU’VE ALREADY COMPLETED THIS SURVEY.',
      completedSurvey: 'THANK YOU FOR COMPLETING THE SURVEY.',
      completedAttestation: 'THANK YOU FOR COMPLETING THE SURVEY.',
      completedRoadMapToSuccess: 'THANK YOU FOR COMPLETING THE SURVEY.'
    },
    completeMessage: 'You’ve already completed this survey. Would you like to take it again?',
    sessionExpired: 'You were away for a bit, so we closed the survey to keep things secure.\nPlease start again.'
  },
  questions: {
    addQuestion: 'Add Question',
    reference: 'Reference Id'
  },
  questionContent: {
    left: {
      questionType: {
        newQuestion: 'Create New Question',
        iconLibraryText: 'Add Question From Library',
        iconCalculationText: 'Add Calculation',
        pageBreakText: 'Add Page Break',
        iconConfigureScoringResults: 'Configure Scoring Results',
        type: 'Question Type',
        questionTitle: 'Question Title',
        questionSubTitle: 'Question',
        scaleRangeTitle: 'Question Response Instruction',
        minimumTitle: 'Left Value',
        optionalTitle: 'Center (optional)',
        maximumTitle: 'Right Value',
        scale: 'Scale',
        domainType: 'Flourishing Domain Type',
        placeholderTitle: 'Example information',
        placeholderQuestion: 'Enter question',
        placeholderAnswer: 'Enter an answer',
        openText: {
          instruction: 'Instruction for text box',
          limitCharacters: '%d character limit for answers',
          remainCharacters: '%s Character Limit',
          numericSettings: 'Numeric Range',
          rangeDescription: 'Allow numbers between %d1 and %d2.',
          outOfRange: '*The range for this input is between %d1 - %d2.',
          rangeInput: 'The range for this input is between %d1 - %d2.',
          greaterStartDate: 'The input is less than start date. The start date should be greater than %d1.',
          consentType: {
            title: 'Consent Delivery Title',
            subHeader: 'Sub-Header',
            linkTitle: 'Link Title',
            link: 'Link',
            content: 'Consent Delivery Content'
          }
        },
        labelAnswerCustomValue: 'Value'
      },
      variables: {
        calcuation: {
          variableName: 'Calculated Variable Name',
          placeholderVariableName: 'Enter a name for the variable',
          placeholderFomular: 'Enter calculations here',
          placeholderExplain: 'Explanation',
          textChooseCategory: 'Choose Category',
          textChooseScoreToConnect: 'Choose Score to Connect'
        }
      },
      pageBreak: {
        transitionText: 'Transition Text (Optional)',
        transitionPlaceholder: 'Enter a description for what comes next in the survey',
        transitionButtonText: 'Transition Button Text',
        transitionButtonPlaceholder: 'Enter button text to transition to the next page',
        addMediaButtonText: 'Add Resource'
      }
    },
    right: {
      addAnswer: 'Add an Answer',
      addQuestionToSurvey: 'Add a Question to Survey',
      editQuestionLogic: 'Question Logic',
      editQuestionOrder: 'Question Order',
      textEditQuestionOrderActive: 'Edit Question Order',
      goToMap: 'GO TO MAP',
      goToMap2: 'Go To Map',
      removeAnswer: 'Remove an Answer',
      questionRequired: 'Make Question Required',
      textAddQuestionToGroup: 'Add Question to Group',
      textRemoveQuestionToGroup: 'Remove Question from Group',
      textEditGroupLogic: 'Group Logic',
      textEditGroupOrder: 'Group Order'
    }
  },
  dialog: {
    unAuthorizedToken: {
      title: 'Session Expired',
      msg: 'Your session has expired. Would you like to be redirected to the login page?',
      type: 'Warning'
    },
    delete: {
      title: 'Delete Question!',
      msg: 'Are you sure that you want to delete this question?',
      survey: {
        title: 'Delete Survey!',
        msg: 'Are you sure that you want to delete this survey?'
      }
    },
    calculateDel: {
      title: 'Delete Calculate Variable!',
      msg: 'Are you sure that you want to delete this calculate variable?'
    },
    pageBreak: {
      delete: {
        title: 'Delete Page Break!',
        msg: 'Are you sure that you want to delete this page break?'
      }
    }
  },
  results: {
    backAllResult: 'ALL FLOURISHING DOMAINS'
  }
};
